import React, { Component } from 'react';
import { connect } from 'react-redux';
import CardWidget from "../card-widget/CardWidget";
import { RouteConstants } from "../route/services/RouteConstants";
import Api from "../../services/api/Api";
import { ApiPaths } from "../../services/api/ApiPaths";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import CardWidgetErrorsContainer from "../card-widget/CardWidgetErrorsContainer";
import CardWidgetTextInput from "../card-widget/CardWidgetTextInput";
import { getLanguage } from "../../store/rootReducer";
import UrlParamsUtil from "../../services/util/UrlParamsUtil";
import ValidationService from '../registration/services/ValidationService';
import { AuthConstants } from '../user/services/AuthConstants';

class WelcomePage extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            errorMessage: null,
            clientId: null

        };
    }

    submitStudentValidateForm = () => {
        if (!ValidationService.isValidEmail(this.email, true)) {
            this.setState({
                errorMessage: "forgotpassword.enter_email_error"
            });
            return;
        }
        let request = { "email": this.email };
        Api.post(ApiPaths.STUDENT_WELCOME_PAGE, request).then(

            (response) => {
                if (response.data.emailExists && response.data.isLocked) {
                    this.props.history.push(RouteConstants.STUDENT_ACCOUNT_LOCKED);
                }
                else if (response.data.emailExists && !response.data.isLocked && !response.data.isDefaultPassword) {
                    window.location = window.location.origin.includes("devta-01") ? AuthConstants.TA_DEV : window.location.origin.includes("qata-02") ? AuthConstants.TA_QA : window.location.origin.includes("localhost") ? AuthConstants.TA_DEV : AuthConstants.TA;
                }
                else if (response.data.emailExists && !response.data.isLocked && response.data.isDefaultPassword) {
                    this.props.history.push({
                        pathname: RouteConstants.STUDENT_PASSWORD_FORCE_RESET,
                        state: { email: this.email }
                    });
                }
                else {
                    this.props.history.push(RouteConstants.STUDENT_ACCOUNT_NOT_SETUP);
                }
            },
            (error) => {
                this.setState({
                    errorMessage: "common.general_processing_error"
                });
            });
    };

    handleEmailChange = (e) => {
        this.email = e.target.value;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.submitStudentValidateForm();
    };

    getStudentLandingPageContent = () => {
        return (
            <form onSubmit={(e) => this.handleSubmit(e)}>
                <CardWidgetContent contentText="student_section.welcome" />
                <CardWidgetErrorsContainer errorMessage={this.state.errorMessage} />
                <CardWidgetTextInput fieldLabel="forgotpassword.email_field_label" onChange={this.handleEmailChange} />
            </form>
        )
    };

    render() {
        return (
            <CardWidget getCardContent={this.getStudentLandingPageContent}
                submitButtonAction={() => this.submitStudentValidateForm()}
                submitButtonText="student_section.next"
                cancelButtonAction={() => this.props.history.goBack()}
                cancelButtonText="student_section.cancel" />
        )
    };

    componentDidMount() {
        let parsedParams = UrlParamsUtil.getQueryParamsFromUrl(this.props);
        if (parsedParams.clientId) {
            this.setState({
                clientId: parsedParams.clientId
            })
        }
    }

}

const mapStateToProps = (state) => {
    return {
        language: getLanguage(state)
    };
};

export default connect(mapStateToProps)(WelcomePage);